import { Routes, Route, Link, NavLink, Navigate } from 'react-router-dom';
import { useAuth } from './context/AuthContext';
import Landing from './pages/Landing';
import SignUp from './pages/SignUp';
import SignIn from './pages/SignIn';
import Map from './pages/Map';
import Breakdown from './pages/Breakdown';
import CityDashboard from './pages/CityDashboard';
import Reports from './pages/Reports';
import Admin from './pages/Admin';
import Pending from './pages/Pending';

export default function App() {
  const { ready, user, approved, signOut } = useAuth();
  if (!ready) return <div className="center muted">Loading…</div>;

  return (
    <>
      <nav className="nav">
        <Link to="/" className="brand">⛽ GasGavel</Link>
        {user && approved && (
          <>
            <NavLink to="/map" className={({ isActive }) => isActive ? 'active' : ''}>Map</NavLink>
            <NavLink to="/breakdown" className={({ isActive }) => isActive ? 'active' : ''}>Breakdown</NavLink>
            <NavLink to="/cities" className={({ isActive }) => isActive ? 'active' : ''}>Cities</NavLink>
            <NavLink to="/reports" className={({ isActive }) => isActive ? 'active' : ''}>Reports</NavLink>
            <NavLink to="/admin" className={({ isActive }) => isActive ? 'active' : ''}>Admin</NavLink>
          </>
        )}
        <span className="spacer" />
        {user ? (
          <>
            <span className="muted small">{user.email}</span>
            <button className="ghost" onClick={signOut}>Sign out</button>
          </>
        ) : (
          <>
            <Link to="/signin">Sign in</Link>
            <Link to="/signup"><button>Create account</button></Link>
          </>
        )}
      </nav>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/signin" element={<SignIn />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/auth/callback" element={<Navigate to="/map" replace />} />
        <Route path="/pending" element={<Pending />} />
        <Route path="/map" element={<Gate><Map /></Gate>} />
        <Route path="/breakdown" element={<Gate><Breakdown /></Gate>} />
        <Route path="/cities" element={<Gate><CityDashboard /></Gate>} />
        <Route path="/reports" element={<Gate><Reports /></Gate>} />
        <Route path="/admin" element={<Gate adminOnly><Admin /></Gate>} />
      </Routes>
    </>
  );
}

function Gate({ children, adminOnly }: { children: React.ReactNode; adminOnly?: boolean }) {
  const { user, approved, idToken } = useAuth();
  if (!user || !idToken) return <Navigate to="/signin" replace />;
  if (!approved) return <Navigate to="/pending" replace />;
  if (adminOnly) {
    const role = JSON.parse(atob(idToken.split('.')[1]))['custom:role'];
    if (role !== 'admin') return <div className="container card">Admins only.</div>;
  }
  return <>{children}</>;
}
